import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import {
  SignInAction,
  SignInByPhoneAction, SignInByServiceAction,
  SignInByUsernameAction,
  SignInResponse,
} from '@triare/auth-redux/dist/saga/auth/signIn';
import { useLocation, useNavigate } from 'react-router-dom';
import OTPCode from './OTPCode';
import { useAuth } from '../../../../store/auth';
import Wrapper from '../Wrapper';

type Values = SignInAction | SignInByUsernameAction | SignInByPhoneAction | SignInByServiceAction | null;

export interface ContentProps {
  onSubmit?: (values: Values) => void
}

export interface SignInProps {
  content: any;
  isOpen: boolean;
  onClose: () => void;
  isSignUpOpen?: boolean;
  setSignUpOpen?: (open: boolean) => void;
  setForgotOpen?: () => void;
}

export default function SignIn({
  content: Content, isOpen, onClose, isSignUpOpen, setSignUpOpen, setForgotOpen,
}: SignInProps) {
  const { signIn: { response, error }, OTP, authorized } = useAuth();
  const [state, setState] = useState<SignInResponse>();
  const [requestData, setRequestData] = useState<Values>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authorized && (
      (state && state.secretKey && !OTP.error && !OTP.response) || (!error && !response && requestData))
    ) {
      onClose();
      /** Specify from which pages we need to redirect to home screen */
      if ([
        '/complete-registration', '/create-account', '/create-account-success',
      ].some((path) => location.pathname.startsWith(path))) {
        navigate('/');
      }
    }
  }, [authorized, error, response, OTP.error, OTP.response, state, requestData, onClose]);

  useEffect(() => {
    if (response && response.secretKey) {
      setState(response);
    }
  }, [response]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      destroyOnClose={!isSignUpOpen}
    >

      {state && state.secretKey && requestData ? (
        <OTPCode
          onBack={() => setState(undefined)}
          email={requestData?.email}
        />
      ) : (
        <Content
          onSubmit={setRequestData}
          isSignInOpen={isOpen}
          onSignInClose={onClose}
          setSignUpOpen={setSignUpOpen}
          isSignUpOpen={isSignUpOpen}
          setForgotOpen={setForgotOpen}
        />
      )}
    </Modal>
  );
}
